import React, { useMemo, useState, useNavigate } from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText, Dialog, FileUpload, InputTextarea, Toast, RadioButton } from "primereact";
import { Formik } from "formik";
import * as Yup from "yup";
import ReactGA from "react-ga4";

import "../../assets/css/badge.css";

class ListaStabilimenti extends React.Component {
  constructor() {
    super();

    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
      {
        id: 2,
        icon: "pi-pencil",
        label: "",
        action: (id) => {
          this.vai(id, "U");
          console.log("Update " + id);
        },
      },
      {
        id: 3,
        icon: "pi-trash",
        label: "",
        action: (id) => {
          this.vai(id, "D");
          console.log("Delete " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
    };

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      xcarica: "sezione",
      caratteristica: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.onPage = this.onPage.bind(this);
    this.aziendaid = 0;
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  componentDidMount() {
    //alert(this.props.location.pathname);
    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    this.aziendaid = this.utente.aziendaid;
    this.caricaDati(1, this.state.pageSize);
  }

  settaImg() {
    var testo =
      Costanti.UrlCallApi +
      "file/get/" +
      this.utente.aziendaid +
      "/stabilimento/" +
      this.state.singolo.id +
      "?" +
      Math.random();
    this.setState({ imgsrc: testo });
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&aziendaid=" + this.aziendaid;
    axios
      .get(Costanti.UrlCallApi + "stabilimento/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });
        this.setState({ caratteristica: res.data.lista1, totalRecords: res.data.conta1, loading: false });
        this.settaImg();
        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  caricaSingolo(id) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "stabilimento/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  salva(values) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });

    if (this.state.tipo == "U") {
      values.status = " ";
      axios
        .post(Costanti.UrlCallApi + "stabilimento/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "D") {
      values.status = "E";
      axios
        .post(Costanti.UrlCallApi + "stabilimento/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "A") {
      var dato = {
        datains: null,
        dataupd: null,
        id: 0,
        codice: values.codice,
        nome: values.nome,
        indirizzo: values.indirizzo,
        aziendaid: this.aziendaid,
        uteins: 1,
        uteupd: null,
        status: " ",
      };
      axios
        .post(Costanti.UrlCallApi + "stabilimento/aggiungi", dato, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }

    setTimeout(() => this.setVisible1(false), 1000);
  }

  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({
          editMode: true,
          singolo: {},
          intestazione: "Aggiungi " + sessionStorage.getItem("DecoStabilimento"),
        });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza " + sessionStorage.getItem("DecoStabilimento") });
        break;
      case "D":
        this.setState({ intestazione: "Elimina " + sessionStorage.getItem("DecoStabilimento") });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica " + sessionStorage.getItem("DecoStabilimento") });
        break;
    }
  }
  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/stabilimenti/" + this.aziendaid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  MyDoc = () => (
    <Document>
      <Page></Page>
    </Document>
  );

  validationSchema() {
    return Yup.object().shape({
      codice: Yup.string().required("Codice obbligatorio").typeError("Codice obbligatorio"),
      nome: Yup.string().required("Nome obbligatorio").typeError("Nome obbligatorio"),
    });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <DataTable
          value={this.state.caratteristica}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista {sessionStorage.getItem("DecoStabilimento")}</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
           
              <Button
                label="Esporta in Pdf"
                onClick={() => this.setPDF(true)}
                icon="pi pi-file-pdf"
                className="p-button-rounded p-button-danger "
              />
              <Button
                label="Aggiungi"
                onClick={() => this.vai(0, "A")}
                icon="pi pi-plus"
                className="p-button-rounded p-button-primary "
              />
            </div>
          }
          responsiveLayout="stack"
        >
          <Column id="id0" field="codice" header="Codice" />
          <Column id="id1" field="nome" header="Nome" />
          <Column id="id2" field="indirizzo" header="Indirizzo" />
          <Column id="id3" field="longitudine" header="Longitudine" />
          <Column id="id4" field="latitudine" header="Latitudine" />

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>

        <Dialog
          header={this.state.intestazione}
          closable={false}
          visible={this.state.visible1}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ maxWidth: "70vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <div className="surface-card p-2  border-round">
              <Formik
                initialValues={{
                  codice: this.state.singolo.codice,
                  nome: this.state.singolo.nome,
                  indirizzo: this.state.singolo.indirizzo,
                }}
                enableReinitialize
                validationSchema={this.validationSchema}
                onSubmit={(values) => {
                  this.salva(values);
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="grid formgrid p-fluid">
                      <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="codice" className="font-medium text-600">
                          Codice
                        </label>
                        <InputText
                          name="codice"
                          readOnly={!this.state.editMode}
                          value={values.codice}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                        <div style={{ color: "red" }}>{errors.codice && touched.codice && errors.codice}</div>{" "}
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="nome" className="font-medium text-600">
                          Nome
                        </label>
                        <InputText
                          name="nome"
                          readOnly={!this.state.editMode}
                          value={values.nome}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                        <div style={{ color: "red" }}>{errors.nome && touched.nome && errors.nome}</div>
                      </div>
                      <div className="field mb-1 col-12 md:col-12">
                        <label htmlFor="indirizzo" className="font-medium text-600">
                          Indirizzo
                        </label>
                        <InputText
                          name="indirizzo"
                          readOnly={!this.state.editMode}
                          value={values.indirizzo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="text"
                        />
                      </div>
                      {this.state.singolo.id > 0 ? (
                        <div className="field mb-1 col-12 md:col-6">
                          <div>
                            <label htmlFor="avatar2" className="font-medium text-600">
                              Multimedia
                            </label>
                            <div className="flex align-items-center">
                              <img src={this.state.imgsrc} style={{ maxWidth: "400px" }} alt="" className="mr-4" />
                              <FileUpload
                                id="avatar2"
                                mode="basic"
                                name="avatar"
                                onError={() =>
                                  this.showMessage("error", "Errore", "Si è verificato un errore nel caricamento")
                                }
                                url={
                                  Costanti.UrlCallApi +
                                  "file/carica/" +
                                  this.utente.aziendaid +
                                  "/stabilimento/" +
                                  this.state.singolo.id
                                }
                                onUpload={() => this.settaImg()}
                                accept="*"
                                maxFileSize={10000000}
                                chooseOptions={{ className: "p-button-plain p-button-outlined" }}
                                chooseLabel="Upload Documento"
                              />
                            </div>
                            <div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <footer>
                      <div className="border-top-1 surface-border pt-3">
                        <Button type="submit" visible={this.state.tipo == "U"} icon="pi pi-save" label="Salva" />
                        <Button visible={this.state.tipo == "A"} icon="pi pi-save" label="Aggiungi" />
                        <Button visible={this.state.tipo == "D"} icon="pi pi-save" label="Elimina" />
                        <Button
                          type="button"
                          icon="pi pi-check"
                          onClick={() => this.setVisible1(false)}
                          label="Chiudi"
                        />
                      </div>
                    </footer>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ListaStabilimenti;
